import { cn } from '@/lib/utils';
import { columnLabelClass } from '@/components/ui/typography.ts';
import NoItems from '@/components/ui/NoItems.tsx';
import MoneyAmountList from '@/features/dashboard/bookingChanges/components/primitives/MoneyAmountList.tsx';
import { SettlementScheduleVm } from '@/features/dashboard/bookingChanges/types/ChangePackageFlowViewModel.ts';
import SettlementScheduleRow from './SettlementScheduleRow.tsx';
import { schedulePanelClass } from './settlementScheduleLayout.ts';

interface SettlementSchedulePanelProps
  extends React.HTMLAttributes<HTMLDivElement> {
  schedule: SettlementScheduleVm;
}

/**
 * Prawa kolumna kroku W2 — harmonogram po zmianie. Jedyny szary blok w karcie:
 * pokazuje skutek paczki, niczego nie da się w nim kliknąć.
 *
 * „Razem do zapłaty” to `totalAfter` z podglądu, czyli suma żywych rat
 * i korekt bez zwrotów — front jej nie składa z wierszy, bo zwrot w tabeli
 * widać, a w należności go nie ma.
 */
const SettlementSchedulePanel = ({
  schedule,
  className,
  ...props
}: SettlementSchedulePanelProps) => (
  <div className={cn(schedulePanelClass, className)} {...props}>
    <div className={columnLabelClass}>Harmonogram po zmianie</div>

    {schedule.rows.length === 0 ? (
      <NoItems
        className="mt-3"
        title="Brak harmonogramu"
        description="Ta rezerwacja nie ma rat, na które można rozłożyć dopłatę."
      />
    ) : (
      <>
        <div className="mt-3 flex flex-col">
          {schedule.rows.map((row, index) => (
            <SettlementScheduleRow
              key={row.id}
              className={cn(index > 0 && 'border-t border-neutral-200')}
              row={row}
            />
          ))}
        </div>

        <div className="mt-3.5 flex items-baseline border-t border-neutral-200 pt-3.5">
          <span className="text-sm font-semibold text-neutral-800">
            Razem do zapłaty
          </span>
          <span className="ml-auto text-xl font-extrabold tabular-nums text-ink">
            <MoneyAmountList values={schedule.totalAfter} />
          </span>
        </div>
      </>
    )}
  </div>
);

export default SettlementSchedulePanel;
